import React from 'react';

export const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const hasWordBoundaryMatch = (text, query) => {
  if (!query || !text.includes(query)) return false;

  let position = text.indexOf(query);
  while (position !== -1) {
    if (position === 0 || text.charAt(position - 1) === ' ') {
      return true;
    }
    position = text.indexOf(query, position + 1);
  }

  return false;
};

export const highlightMatch = (text, query) => {
  if (!query) return text;
  const parts = text.split(new RegExp(`(${escapeRegex(query)})`, 'gi'));
  return parts.map((part, i) => (
    part.toLowerCase() === query.toLowerCase()
      ? <span key={i} className="match">{part}</span>
      : part
  ));
};

export const getMatchingCategories = (options, query) => (
  options.filter((item) => hasWordBoundaryMatch(item.text, query))
);

export const getMatchingSubCategories = (subCategoriesMap, query, excludeTexts = []) => {
  const seen = new Set(excludeTexts);
  const matches = [];

  Object.keys(subCategoriesMap).forEach((parentKey) => {
    subCategoriesMap[parentKey].forEach((item) => {
      if (hasWordBoundaryMatch(item.text, query) && !seen.has(item.text)) {
        seen.add(item.text);
        matches.push({ item, parentKey });
      }
    });
  });

  return matches;
};

export const limitCategoryResults = (categoryMatches, subCategoryMatches, limit = 6) => {
  const categories = categoryMatches.slice(0, limit);
  const subCategories = subCategoryMatches.slice(0, Math.max(0, limit - categories.length));
  return { categories, subCategories };
};
